// filepath: apps/web/src/features/directory/person-summary/PersonSummaryHeader.tsx
//
// FR-UI-DIR-1 AC-2 -- header card for the person summary.
//
// Wraps the design-system DocumentHeader primitive (DocumentHeader
// .tsx port in apps/web/src/design-system/) so the SPA composition
// matches the pinned design composition pin db65d49.
//
// INV-2: every field rendered here comes from the PersonSummary
// server payload -- the client never invents a display name or PII
// substitute from related records.
//
// ISS-518 BA option (a): the pre-ISS-518 denormalized helpers
// (`title`, `primary_unit_name`, `tags`) + the `primary_*_id`
// family were DROPPED per the BA ruling -- Go never emitted them
// and the spec's "No new backend" forecloses them.

import React from "react";
import { DocumentHeader } from "@/design-system";
import { useTranslation } from "@/i18n/useTranslation";
import type { PersonSummary } from "../types";

export interface PersonSummaryHeaderProps {
  person: PersonSummary;
}

export function PersonSummaryHeader({
  person,
}: PersonSummaryHeaderProps): React.ReactElement {
  const { t } = useTranslation();
  return (
    <DocumentHeader
      data-testid="person-summary-header"
      title={
        person.display_name ?? t("directory.people.unnamed", "Unnamed person")
      }
      status={
        person.status
          ? t(`directory.people.status.${person.status}`, person.status)
          : undefined
      }
      statusTone={person.status === "active" ? "success" : "neutral"}
    />
  );
}
